import {nameReg, emailReg} from "../../regex.js";

//This is copied over from static-asssets and modified to work with the vue implementation of the social sharing icons; see docs in EmailSharingModal.vue for explanations
var reCaptchaUtil = function() {
	return {
		reloadSuccess: function() {},
		reload: function(onReloadSuccess) {
			this.reloadSuccess = onReloadSuccess;
			Recaptcha.reload();
		},
		reloadAndCopy: function(copyAfterSelector) {
			this.reload(function() {
				var copyAfterElement = $(copyAfterSelector || '#messageBlock');
				copyAfterElement.next().remove();
				copyAfterElement.after($('#newcaptchaDiv').html());	
			});
		}
	}
}();  

// var openOverLay = false;

export function validateEmailForm(form) {
    if(validForm()) {
        return false;
    } else {
    	$('form#emailToFriendForm').submit();
	}
	return false;
}

export function validForm() {
	var error = false;
	if($("#recipientEmails").val().trim() == '') {
		error = true;
		$("#recipentEmailErrMsg").removeClass('show').addClass('dontShow');
		$("#emptyRecipentEmailErrMsg").removeClass('dontShow').addClass('show');
		$("#recipientEmailLabel").addClass('error-label');
	}else if (!validateMultipleEmailIds()) {
		error = true;
		$("#emptyRecipentEmailErrMsg").removeClass('show').addClass('dontShow');
		$("#recipentEmailErrMsg").removeClass('dontShow').addClass('show');
		$("#recipientEmailLabel").addClass('error-label');
	} else {
		$("#emptyRecipentEmailErrMsg").removeClass('show').addClass('dontShow');
		$("#recipentEmailErrMsg").removeClass('show').addClass('dontShow');
		$("#recipientEmailLabel").removeClass('error-label');
	}
	if($("#yourName").val().trim() == '') {
		error = true;
		$("#emptyUserNameErrMsg").removeClass('dontShow').addClass('show');
		$("#userNameErrMsg").removeClass('show').addClass('dontShow');
		$("#nameLabel").addClass('error-label');
	} else if (!validateName()) {
		error = true;
		$("#emptyUserNameErrMsg").removeClass('show').addClass('dontShow');
		$("#userNameErrMsg").removeClass('dontShow').addClass('show');
		$("#nameLabel").addClass('error-label');
	} else {
		$("#emptyUserNameErrMsg").removeClass('show').addClass('dontShow');
		$("#userNameErrMsg").removeClass('show').addClass('dontShow');
		$("#nameLabel").removeClass('error-label');
	}
	
	if($("#yourEmail").val().trim() == '') {
		error = true;
		$("#emptyUserEmailErrMsg").removeClass('dontShow').addClass('show');
		$("#userEmailErrMsg").removeClass('show').addClass('dontShow');
		$("#userEmailLabel").addClass('error-label');
	}else if (!validateUserEmailId()) {
		error = true;
		$("#userEmailErrMsg").removeClass('dontShow').addClass('show');
		$("#emptyUserEmailErrMsg").removeClass('show').addClass('dontShow');
		$("#userEmailLabel").addClass('error-label');
	} else {
		$("#emptyUserEmailErrMsg").removeClass('show').addClass('dontShow');
		$("#userEmailErrMsg").removeClass('show').addClass('dontShow');
		$("#userEmailLabel").removeClass('error-label');
	}
	if(grecaptcha.getResponse().length == 0){
		error = true;
		$("#incorrectCaptchaSolution").removeClass('dontShow');
		$("#captchaResponseLabel").addClass('error-label');
	}
	if (error) {
		$("#emailErrorMsgContent").removeClass('dontShow').addClass('show');
		return true;
	} else {
		// Fix for 10575 - Need to remove double quotes from user input fields before sending email
		var emailMsg = $("#emailmessage").val() == undefined ? '' : $("#emailmessage").val().trim();
		if(emailMsg != '') {
			emailMsg = emailMsg.replace(/"/g,'');
			$("#emailmessage").val(emailMsg);
		}
		$("#emailErrorMsgContent").removeClass('show').addClass('dontShow');
		return false;
	}
}

export function validateName() {
	var yourName = $("#yourName").val();
	if (!nameReg.test(yourName)) {
		return false;
	} else {
		return true;
	}
}

export function validateUserEmailId() {
	var emailId = $("#yourEmail").val();
	if (!emailReg.test(emailId.trim())) {
		return false;
	} else {
		return true;
	}
}

export function validateMultipleEmailIds() {
	var multipleIds = $("#recipientEmails").val();
	var Ids = multipleIds.split(",");
	for ( var i = 0; i < Ids.length; i++) {
		if (!validateEmailId(Ids[i].trim())) {
			return false;
		}
	}
	return true;
}

export function validateEmailId(emailId) {
	return (emailReg.test(emailId)) ? true : false;
}

export function loadEmailOverlay(id, contentType, contentParams) {
	//altered to bring in contentParams over from Vue; this contains info that was previously in hidden inputs
	var url = contextRoot+"/includes/emailtofriendoverlay.jsp";
	var div = "emailOverlayDiv";
	loadEmailOverlayContent(url, div, id, contentType, true, contentParams);
}

var savedEmailParamsObject = null;

var loadEmailOverlayObject = function() {
	return {
		loadEmailOverlayAction: function(emailParamsObject) {
			var url = emailParamsObject.url;
			var div = emailParamsObject.div;
			var id = emailParamsObject.id;
			var contentType = emailParamsObject.contentType;
			var openOverLay = emailParamsObject.openOverLay;
			var isArtifiCake = emailParamsObject.isArtifiImage;
			var srcUrl = emailParamsObject.srcUrl;
			var contentName = emailParamsObject.contentName;
			var contentDesc = emailParamsObject.contentDesc;
			var contentUrl = emailParamsObject.contentUrl;
			var contentExpDate = emailParamsObject.contentExpDate;
			var divId = '#' + div;
			
			$.ajaxQueue({
				url : url,
				dataType : "html",
				type : "GET",
				data : {
					successUrl : srcUrl,
					contentId : id,
					contentType : contentType,
					contentName : contentName,
					contentDesc : contentDesc,
					contentUrl : contentUrl,
					contentExpDate : contentExpDate,
					artifiCake : isArtifiCake,
				},
				success : function(data) {
					var $divId = $(divId);

					$divId.html(data); 

					//This is to remove the back link added by emailtofriendoverlay.jsp. This is added for whenever its in the CDM to be able to bring it back to the modal. Since we're in Vue we dont need this.
					//This is super janky, but unless we go digging in the original file and remove it, we have to do it here.
					$divId.find('.close-reveal-modal').remove();
					$divId.find('.back').remove();

					//Changes the cancel button to not look for foundation stuff and binds the appropriate validation function to the submit button
					$divId.find('#cancel').attr('onclick', "$('#email-sharing-modal').find('button.close').trigger('click');return false;");
					$divId.on('click','button#sendEmailToFriend',validateEmailForm);

					if (openOverLay) {
						var recaptchaSiteKey = $("#recaptchaSiteKey").val();
						grecaptcha.render("emailOverlayReCaptcha", {"sitekey":recaptchaSiteKey});
					}
				}
			});
			
		}
	}
}();

export function loadEmailOverlayContent(url, div, id, contentType, openOverLay, contentParams) {
	var emailParamsObject = {};
	emailParamsObject.url = url;
	emailParamsObject.div = div;
	emailParamsObject.id = id;
	emailParamsObject.contentType = contentType;
	emailParamsObject.openOverLay = openOverLay;
	emailParamsObject.isArtifiImage = false;
	emailParamsObject.contentExpDate = contentParams.contentExpDate;
	emailParamsObject.contentDesc = contentParams.contentDesc;
	emailParamsObject.contentUrl = contentParams.contentUrl;
	emailParamsObject.srcUrl = contentParams.srcUrl;
	if (typeof artifiEnabled != 'undefined' && artifiEnabled && contentType == 'PRODUCT') {
    	savedEmailParamsObject = emailParamsObject;
    	saveArtifiAction = "EMAIL_TO_FRIEND";
    	Artifi.AddToCart();
        return;
    }
	loadEmailOverlayObject.loadEmailOverlayAction(emailParamsObject);
}

function closeEmailModal(){
	// order matters
	//not sure this is entirely necessary anymore but will leave here for now 
	$.modal.close();
	$("#emailOverlayDiv").empty();
}

export function loadEmailSuccessOverlay(){
    $("#emailSuccessOverlayDiv").load(contextRoot+"/includes/emailsuccessoverlay.jsp");
    $("#emailSuccessOverlayDiv").addClass('reveal-modal small').attr('data-reveal','');
    $(document).ready(function(){$("#emailSuccessOverlayDiv").foundation('reveal','open');})
}

function loadProfileUpdateOverlay(page){
    $("#profileUpdateOverlayDiv").load(contextRoot+"/includes/profileupdateoverlay.jsp?page="+page);
    $("#profileUpdateOverlayDiv").modal({minWidth:475, minHeight:235});
}
